<template>
  <component :is="isMoova ? 'RegisterFormMoova' : 'RegisterFormSaas'" />
</template>

<script>
import RegisterFormMoova from '@/components/RegisterFormMoova'
import RegisterFormSaas from '@/components/RegisterFormSaas'

export default {
  name: 'RegisterForm',
  components: {
    RegisterFormMoova,
    RegisterFormSaas
  },
  computed: {
    isMoova() {
      return this.$eid === 1 && window.countries.find(x => x.iso_code === window.country).name.toLowerCase().indexOf('saas') === -1
    }
  }
}
</script>
